
import Hero from './components/Hero';
import ContactForm from './components/ContactForm';
import LocationMap from './components/LocationMap';

export default function ContactPage() {
  return (
    <div className="min-h-screen">
      <Hero />
      <ContactForm />
      <LocationMap />
    </div>
  );
}
